angular.module('iSkanerLsn', ['ja.qr']);